import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// Services
import { ElasticService } from './../../../services/elastic';
// External
import { AngularFireDatabase } from 'angularfire2/database';
import { ApiService } from './../../../services/api';

import { OAuthService } from './../../../services/o-auth';
import { Club } from './../../../models/club'
import { AdminPostTypes } from './../../../models/post-types'
import { FormsService } from './../../../services/forms';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AngularFireAuth } from 'angularfire2/auth';

import * as lodash from 'lodash';
@Component({
  selector: "app-insights",
  templateUrl: 'insight.component.html'
})
export class InsightComponent implements OnInit {

  public club: Club;
  public follow: any;
  public form: FormGroup;
  public adminId: string
  public notification: Array<{ id: string; count: number; name: string; checkImage: string; unCheckImage: string; isActive: boolean }>;
  public offerCount: number;
  public insightFollower: Array<any>;
  public notifyType = ''
  constructor(private apiService: ApiService, private fireAuth: AngularFireAuth, private route: Router, private elasticService: ElasticService, private fireDatabase: AngularFireDatabase, private oAuthService: OAuthService, public formsService: FormsService) {
    this.form = new FormGroup({
      title: new FormControl('', Validators.required),
      body: new FormControl('', Validators.required),
      author: new FormControl("GOLFHUBBER")
    });
  }
  ngOnInit(): void {
    this.adminId = "GOLFHUBBER"

    this.fireDatabase.list(`/users/`, { query: { orderByChild: "isAdminInsightDone", equalTo: true } })
      .subscribe(result => {
        this.createNotification();

        this.getClubInsight();
        if (result) {
          this.follow = [];
          this.follow = result;
          lodash.forEach(result, (item, key) => {
            if (item) {
              this.apiService.object(`/user-push-settings/${item.$key}/${this.adminId}`)
                .then(result => {
                  this.increaseNotification();
                  lodash.forEach(result, (item1, key1) => {

                    if (item1) {
                      for (var i = 0; i < this.notification.length; i++) {
                        if (key1 == this.notification[i].id) {
                          this.notification[i].count--;

                        }
                      }
                    }

                  })
                })
            }
          })
        }
      }
      )
  }
  public followerClick(follow) {
    $('#myModal').modal('hide');
    this.route.navigate(['/components/userDetail', follow.$key,false]);
  }
  private getClubInsight() {
    this.apiService.object(`/users/${this.fireAuth.auth.currentUser.uid}/insights`)
      .then(result => {
        //  console.log(result)
        //     console.log(result)
        lodash.forEach(result, (item, key) => {

          for (var i = 0; i < this.notification.length; i++) {
            if (key == this.notification[i].id && item) {

              this.notification[i].isActive = false;
              //    console.log(key + "  " + this.notification[i].id + "  " + item)
              // console.log(this.notification)

            }
          }

        })

      })
  }


  public getFollower(id) {
    // console.log(this.follow)
    this.insightFollower = [];

    // var followUid = [];
    lodash.forEach(this.follow, (item, key) => {
      if (item) {
        // followUid.push(item.$key)

        //  console.log("item   " + item + "  key  " + key)
        this.apiService.object(`/user-push-settings/${item.$key}/${this.adminId}/${id}`)
          .then(result => {
            // console.log(result)
            // if (result) {
            //   lodash.forEach(result, (item1, key1) => {

            //     if (item1) {
            //         if (id == key1) {
            //           var i = followUid.indexOf(key);
            //           if (i != -1) {
            //             followUid.splice(i, 1)
            //           }
            //         } else {


            //         }
            //     }


            //   })
            // }

            if (result && !result.$value) {
              this.apiService.object(`/users/${item.$key}`)
                .then((user: any) => {

                  this.insightFollower.push(user)
                });
            }

          })
      }
    })
    // lodash.forEach(followUid, (item, key) => {
    //   this.fireDatabase.object(`/users/${item}`)
    //     .subscribe((user: any) => {

    //       this.insightFollower.push(user)
    //     });
    // })
    $('#myModal').modal('show');
  }
  public insightClick(not) {
    if (not.isActive) {
      if (confirm('Are you sure, you want to disable the notification?')) {

        this.apiService.set(`/users/${this.fireAuth.auth.currentUser.uid}/insights/${not.id}`, true)
          .then(() => {
            // this.getClubInsight();
            this.ngOnInit();
          })
          .catch(error => {
            console.error(error);

          });
      }
    } else {
      if (confirm('Are you sure, you want to enable the notification?')) {

        this.apiService.set(`/users/${this.fireAuth.auth.currentUser.uid}/insights/${not.id}`, null)
          .then(() => {
            // this.getClubInsight();
            this.ngOnInit();
          })
          .catch(error => {
            console.error(error);

          });
      }
    }

  }
  createNotification() {
    this.notification = [];

    lodash.forEach(AdminPostTypes, (item, key) => {
      this.notification.push({ id: key, name: item[0], count: 0, checkImage: item[1], unCheckImage: item[2], isActive: true })
    })
  }
  increaseNotification() {
    lodash.forEach(this.notification, (item, key) => {

      item.count++;
    })
    // console.log(this.notification)

  }
  openPopup(id) {
    $('#PostModal').modal('show');
    this.notifyType = id
  }
  public submit() {

    var followUid = [];
    lodash.forEach(this.follow, (item, key) => {
      if (item) {
        followUid.push(key)
        const fireObject = this.fireDatabase.object(`/user-push-settings/${key}/${this.adminId}`)
          .subscribe(result => {
            if (result) {
              lodash.forEach(result, (item1, key1) => {
                if (key1 == this.adminId) {
                  if (item1) {
                    lodash.forEach(item1, (item2, key2) => {
                      if (this.notifyType == key2 && item2) {
                        var i = followUid.indexOf(key);
                        if (i != -1) {
                          followUid.splice(i, 1)
                        }
                      }
                    })
                  }
                }
              })
            }
          })
      }
    })

    var form = this.form.value
    form.type = this.notifyType
    form.users = followUid
    console.log(form)
    // this.fireDatabase.database.ref(`/server-process/admin-notification/GOLFHUBBER/${this.fireAuth.auth.currentUser.uid}`)
    //   .set(form)
    //   .then(() => {
    //     alert('Notification is Sent!')
    //     $('#PostModal').modal('hide');

    //   })
    //   .catch(error => {
    //     console.error(error);
    //   });
  }
}



